import PropTypes from "prop-types";
import {
  Card,
  CardContent,
  CardHeader,
  Loading,
  MenuCustom,
} from "../../components";
import "./minimal-layout.scss";

const Minimal = ({
  children,
  loading,
  ButtonMenu,
  title,
  cardAction,
  action,
  filterActions
}) => {
  return (
    <div className="minimal-layout-container">
      {ButtonMenu && (
        <div className="menu-custom-minimal">
          <MenuCustom ButtonMenu={ButtonMenu} />
        </div>
      )}

      <Card className="minimal-layout-card">
        <CardHeader title={title} botaoVoltar={!ButtonMenu} action={action} filterActions={filterActions}/>

        <CardContent className="minimal-layout-card-content rolagem">
          {children}
        </CardContent>

        {cardAction && <div className="minimal-card-actions">{cardAction}</div>}
      </Card>

      <Loading loading={loading} />
    </div>
  );
};

Minimal.propTypes = {
  children: PropTypes.node,
  loading: PropTypes.bool,
  ButtonMenu: PropTypes.node,
  title: PropTypes.string,
  cardAction: PropTypes.node,
};

export default Minimal;
